export const capitalizeString = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export const capitalizeEveryWord = (input: string): string =>
  input.split(' ').map(capitalizeString).join(' ');
